import Secure from "./components/Secure"
import Heading from "./components/Heading"
import Footer from "./components/Footer"
import "./css/index.css"

function App() {
  return (
    <>
    <Heading/>
   <Secure/>
   <Footer/>
    </>
  );
}

export default App;
